const mockedUrls = [
  'auth/profile',
  'auth/login',
  'Catalog/products/1/coverages',
  'MOCK_PACKAGE_ENDPOINT',
];

export default function urlIsMocked(urlString: string): boolean {
  return mockedUrls.includes(urlString);
}
